import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiHome, FiArrowLeft } from 'react-icons/fi';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem 1rem;
`;

const Content = styled(motion.div)`
  text-align: center;
  max-width: 500px;

  h1 {
    font-size: 6rem;
    font-weight: 700;
    color: #2D5016;
    margin-bottom: 1rem;
    line-height: 1;

    @media (max-width: 768px) {
      font-size: 4rem;
    }
  }

  h2 {
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.125rem;
    color: #666;
    margin-bottom: 2rem;
    line-height: 1.6;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
`;

const PrimaryButton = styled(Button)`
  background: #2D5016;
  color: white;

  &:hover {
    background: #1a3a0e;
    transform: translateY(-1px);
  }
`;

const SecondaryButton = styled(Button)`
  background: transparent;
  color: #2D5016;
  border: 2px solid #2D5016;

  &:hover {
    background: #2D5016;
    color: white;
  }
`;

const NotFound = () => {
  return (
    <Container>
      <Content
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>
          Sorry, the page you're looking for doesn't exist. 
          It might have been moved, deleted, or you entered the wrong URL.
        </p>
        <ButtonGroup>
          <PrimaryButton to="/">
            <FiHome />
            Go Home
          </PrimaryButton>
          <SecondaryButton onClick={() => window.history.back()}>
            <FiArrowLeft />
            Go Back
          </SecondaryButton>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

export default NotFound;
